<template>
    <div class="row">
        <div class="col-12">
            <div class="page-title-box">
                <h4 class="page-title">Pipeline</h4>
            </div>
        </div>
    </div>     
    <!-- end page title --> 

    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col tasks" v-for="(stage, index) in pipelineStages" :key="stage">
                    <h5 class="mt-0 task-header">{{ stage.toUpperCase() }}</h5>
                    <!--<draggable v-model="projects_by_stage[stage]" @end="handleDragEnd">
                        <div
                            class="project"
                            v-for="project in projects_by_stage[stage]"
                            :key="project.id"
                        >
                            {{ project.name }}
                        </div>
                        <template #item="{ element }">
                            <div class="project">{{ element.name }}</div>
                        </template>
                        <template #item="{ element }">
                            <div class="project">{{ element.name }}</div>
                        </template>
                    </draggable>-->
                    <draggable v-model="projectsByStages[stage]" @end="handleDragEnd" group="pipeline" :id="stage">
                        <div class="card" v-for="(project, key) in projectsByStages[stage]" :id="project.id" :key="project.id">
                            <div class="card-body">
                                <span class="badge bg-secondary text-light">{{ (project.type).toUpperCase() }}</span>
                                <span class="badge bg-primary text-light ml-2 text-right" @click="edit(project)">Details</span>
                                <h5><a :href="'/projects/' + project.id" target="_blank">{{ project.project_name }}</a></h5>
                                <p>{{ project.revenue }} / {{ project.days }}</p>
                                <p>{{ formatDate(project.start_date) }} - {{ formatDate(project.end_date) }}</p>
                            </div>
                        </div>
                    </draggable>
                </div>                                            
            </div>
        </div>
    </div>   
    
    <Create
        v-if="isOpen"
        @modelStatusChanged="modalStatus"
        :project="project"
        :customers="customers"
        :users="users"
        :isEdit="isEdit"
    />
    <confirm-box
        v-if="showConfirmBox"
        :confirmed="deleteProject"
        @hidden="showConfirmBox = false"
        heading="Warning!"
        :message="deleteConfirmation"
        confirmText="Yes"
        cancelText="No"
    />
</template>
<script>

import Main from "@/Layouts/Main.vue";
import Create from "@/Pages/Project/Form.vue";
import EditButton from "@/Components/EditButton.vue";
import DeleteButton from "@/Components/DeleteButton.vue";
import ConfirmBox from "@/Components/ConfirmBox.vue";
import Pagination from "@/Components/Pagination.vue";
import { VueDraggableNext } from 'vue-draggable-next';
import moment from 'moment';
import axios from 'axios';

export default {
    layout: Main,
    props: {
        auth: Object,
        errors: Object,
        projects: Object,
        projects_by_stage: Array,
        users: Array,
        customers: Array,
        flash: Object,
    },
    components: {
        Create,
        EditButton,
        DeleteButton,
        ConfirmBox,
        Pagination,
        draggable: VueDraggableNext,
    },
    data() {
        return {
            project: null,
            isOpen: false,
            isEdit: false,
            showConfirmBox: false,
            pipelineStages: [
                'lead',
                'develop',
                'purpose',
                'contract',
                'initiate',
                'run',
                'wrap_up',
                'bill',
                'close',
            ],
            projectsByStages: []
        };
    },
    methods: {
        formatDate (date) {
            return moment(date).format('Do MMM YYYY')
        },
        edit(project) {
            this.project = project;
            
            this.isEdit = true;
            this.isOpen = true;
        },
        addNew () {
            this.project = null;
            
            this.isEdit = false;
            this.isOpen = true;
        },
        confirnDelete(project) {
            this.project = project;
            this.showConfirmBox = true;
        },
        modalStatus(status) {
            this.isOpen = status;
        },
        hideConfirmation() {
            this.showConfirmBox = false;
        },
        deleteProject() {
            this.$inertia.delete(
                this.route("projects.destroy", this.project.id)
            );
        },
        handleDragEnd(event) {
            // Update project's stage and make AJAX request
            const movedProject = event.item;
            const newStage = event.to.id;;

            // Find the old stage of the project
            let oldStage = event.from.id;
            
            /*for (const stage in this.pipelineStages) {
                if (this.projectsByStages[stage] && this.projectsByStages[stage].includes(movedProject)) {
                    oldStage = stage;
                    break;
                }
            }*/

            if (oldStage && oldStage !== newStage) {
                
                // Update project's stage in the projects array
                const projectID = event.item.id

                this.updateProjectStage(projectID, newStage);
            }
        },
        async updateProjectStage (projectId, newStage) {
            try {
                const response = await axios.post('/project/set-stage', {
                    project_id: projectId,
                    stage: newStage
                }); // Replace with your actual endpoint
                console.log('Member removec:', response.data);
                // Optionally, you can update your UI or perform other actions here
            } catch (error) {
                console.error('Error removing member:', error);
            }
        }
    },

    computed: {
        deleteConfirmation() {
            return `Are you sure went to delete ${this.project.name}?`;
        },
    },
    mounted() {
        this.$store.dispatch("setAuth", this.auth);
        
        this.projectsByStages = this.projects_by_stage;

        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
    updated() {
        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
};
</script>

<style scoped>
.project {
    border: 1px solid #e2e2e2;
    border-radius: 5px;
    padding: 8px 10px;
    margin-bottom: 11px;
    cursor: pointer;
}
</style>
